import React, { Component } from 'react';

import {Route, Switch, withRouter} from "react-router-dom"

import Home from "./pages/home"
import Header from './components/header';
import Footer from './components/footer';
import NotFound from './pages/notFound';

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
        darkTheme: true
    }

    this.toggleTheme = this.toggleTheme.bind(this)
  }

  toggleTheme() {
    this.setState({
        darkTheme: (this.state.darkTheme) ? false : true
    })
  }

  render() {

    const Routes = [
      {name:"Home", path: "/", component:Home, exact:true,},
    ]

    const RouteComponents = Routes.map(({path,component,exact}, key) => <Route key={key} path={path} exact={exact} component={component}/>);
    const PageName = Routes.map(({name,path}) => (window.location.pathname === path) ? name : false )

    return(
      <>
        <Header page={PageName} toggleTheme={this.toggleTheme} darkTheme={this.state.darkTheme}/>
        <Switch>
          {RouteComponents}        
          <Route component={NotFound}/>
        </Switch>
        <Footer darkTheme={this.state.darkTheme}/>
      </>
    );
  }
}
 
export default withRouter(App);